


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Alert, Button, Checkbox, CheckboxGroup } from 'element-ui';

@Component({
  components: {
    'el-alert': Alert,
    'el-button': Button,
    'el-checkbox': Checkbox,
    'el-checkbox-group': CheckboxGroup
  }
})
export default class DeleteTemplate extends Vue {
  private templates = this.$store.state.BillItem.quoteTemplates;
  private ids = [];
  private error = false;

  private close() {
    this.error = false;
    this.$emit('close');
  }

  private openDeleteModal() {
    if (this.ids.length) {
      this.$store.dispatch(
        'App/openConfirmationModal',
        {
          dispatch: 'BillItem/deleteTemplate',
          payload: this.ids
        });
    } else {
      this.error = true;
    }
  }

  @Watch('$store.state.BillItem.closeQuoteDeleteTemplate')
  private closeModal(storedValue: boolean) {
    if (storedValue) {
      this.close();
      this.$store.commit('BillItem/setCloseQuoteTemplate', false);
    }
  }
}
